import { useState, useEffect } from 'react';
import HttpInterceptor from '../lib/HttpInterceptor';
import { DATE_FORMATS, TIME_FORMATS } from '../constants/appConstants';

/**
 * Custom hook to fetch and manage user's date/time format settings
 * Provides consistent access to dateFormat and timeFormat across all components
 */
export const useDateTimeSettings = () => {
  const [dateTimeSettings, setDateTimeSettings] = useState({
    dateFormat: DATE_FORMATS.DD_MM_YYYY, // Default
    timeFormat: TIME_FORMATS.TWELVE_HOUR, // Default
    isLoading: true
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await HttpInterceptor.get('/api/trainer-settings', {
          showErrorToast: false // Suppress error toasts for settings
        });
        
        if (response.data?.data) {
          setDateTimeSettings({
            dateFormat: response.data.data.dateFormat || DATE_FORMATS.DD_MM_YYYY,
            timeFormat: response.data.data.timeFormat || TIME_FORMATS.TWELVE_HOUR,
            isLoading: false
          });
        } else {
          setDateTimeSettings(prev => ({ ...prev, isLoading: false }));
        }
      } catch (err) {
        // Silently fail - use defaults
        console.log('Could not fetch date/time format settings, using defaults');
        setDateTimeSettings(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchSettings();
  }, []);

  return dateTimeSettings;
};

